import React, { memo, useEffect, useState } from "react";
import { getGradeCategory } from "../../config/ListLesson";
import "./ChallengeIKMC.style.css";
import ConstantStrings from "../../constants/ConstantStrings";
import { getLevelIKMCByGrade } from "../../templates/helper/getLevelByGrade";
import { getConstantStringByLanguage } from "../../templates/helper/getConstantStringByLanguage";

const SelectLevelIKMC = memo(({ handleSelect, listLevelId }) => {
  const [checkAll, setCheckAll] = useState(false);
  const [selected, setSelected] = useState([]);
  const [listGrade, setListGrade] = useState([]);
  // const cookies = new Cookies();
  // const token = cookies.get("signinUser");
  const handleCheckAll = () => {
    setCheckAll(!checkAll);
    setSelected(listGrade.map((item) => item._id));
    handleSelect(listGrade.map((item) => item._id));
    if (checkAll) {
      setSelected([]);
      handleSelect([]);
    }
  };
  const handleCheck = (_id) => {
    const gradeIndex = listGrade.findIndex((item) => item._id === _id);
    const nextGradeId = listGrade[gradeIndex + 1]._id;
    const lastGradeId = listGrade[listGrade.length - 1]._id;
    var filter = [nextGradeId,_id]
    if (gradeIndex +2 === listGrade.length -1) {
      filter = [...filter,lastGradeId]
    }
    if (selected.includes(_id)) {
      setSelected(selected.filter((item) => item !== _id));
      setCheckAll(false);
      handleSelect(listLevelId.filter((item) => !filter.includes(item)));
    } else {
      if ([...selected, _id].length === 4) {
        setCheckAll(true);
        setSelected(listGrade.map((item) => item._id));
        handleSelect(listGrade.map((item) => item._id));
      } else {
        setCheckAll(false);
        setSelected([...selected, _id]);
        if (gradeIndex + 1 < listGrade.length) {
          if (gradeIndex + 2 === listGrade.length - 1) {
            handleSelect([
              ...listLevelId,
              _id,
              listGrade[gradeIndex + 1]?._id,
              listGrade[gradeIndex + 2]?._id,
            ]);
          } else {
            handleSelect([...listLevelId, _id, listGrade[gradeIndex + 1]?._id]);
          }
        } else {
          handleSelect([...listLevelId, _id]);
        }
      }
    }
  };
  const handleChange = (name, check, value) => {
    if (name && name === "checkAll") {
      if (check) {
        handleSelect(value);
      } else {
        handleSelect([]);
      }
    } else if (check) {
      handleSelect([...selected, value]);
    } else {
      handleSelect(selected.filter((i) => i !== value));
    }
  };
  useEffect(() => {
    const getListGrades = async () => {
      const { result } = await getGradeCategory();
      setListGrade(result.filter((item) => !ConstantStrings.GRADE_ID_HIDES.includes(item._id)));
    };
    if (listGrade.length <= 0) {
      getListGrades();
    }
  }, [listGrade.length]);
  return (
    <div>
      <div
        className="is-flex is-flex-direction-column is-justify-content-center is-align-items-start"
        style={{
          width: "25rem",
          // height: "23.375rem",
          gap: "1rem",
          borderRadius: "0.125rem",
        }}
      >
        {listGrade &&
          listGrade
            .filter((item) => !ConstantStrings.GRADE_ID_HIDES.includes(item._id))
            .map((item, index) => {
              return (
                <button
                  className={`${
                    item.name === "Lớp 2" ||
                    item.name === "Lớp 4" ||
                    item.name === "Lớp 6" ||
                    item.name === "Lớp 8" ||
                    item.name === "Lớp 10"||
                    item.name === "Lớp 12" 
                      ? "is-hidden"
                      : ""
                  } is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center btn-button-IKMC`}
                  key={index}
                  onClick={() => {
                    handleCheck(item._id);
                  }}
                  style={
                    checkAll || selected.includes(item._id)
                      ? {
                          color: "#FAFBFC",
                          backgroundColor: "#0A2A66",
                        }
                      : { boxShadow: "0.125rem 0.125rem 0rem 0rem #0A2A66" }
                  }
                >
                  <p
                    className="has-text-weight-bold"
                    style={
                      checkAll || selected.includes(item._id)
                        ? {
                            color: "#fff",
                            fontSize: "1.125rem",
                          }
                        : {
                            color: "#0A2A66",
                            fontSize: "1.125rem",
                          }
                    }
                  >
                    {getLevelIKMCByGrade(item.name)}
                  </p>
                  <input
                    onClick={() => {
                      handleCheck(item._id);
                    }}
                    onChange={(e) => {
                      handleChange(e.target.name, e.target.checked, item._id);
                    }}
                    checked={
                      checkAll
                        ? checkAll
                        : selected.includes(item._id)
                        ? true
                        : false
                    }
                    type={"checkbox"}
                    style={{
                      width: "1.5rem",
                      height: "1.5rem",
                      backgroundColor: "#FAFBFC",
                      cursor: "pointer",
                    }}
                  />
                </button>
              );
            })}
        <div
          className="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center btn-button-IKMC"
          onClick={handleCheckAll}
          style={
            checkAll
              ? {
                  color: "#FAFBFC",
                  backgroundColor: "#0A2A66",
                }
              : { boxShadow: "0.125rem 0.125rem 0rem 0rem #0A2A66" }
          }
        >
          <p
            className="has-text-weight-bold"
            style={
              checkAll
                ? {
                    color: "#fff",
                    fontSize: "1.125rem",
                  }
                : {
                    color: "#0A2A66",
                    fontSize: "1.125rem",
                  }
            }
          >
            {getConstantStringByLanguage(ConstantStrings.SELECT_ALL)}
          </p>
          <input
            name="checkAll"
            onChange={(e) => {
              handleChange(
                e.target.name,
                e.target.checked,
                listGrade.map((item) => item._id)
              );
            }}
            onClick={handleCheckAll}
            checked={checkAll}
            type={"checkbox"}
            style={{
              width: "1.5rem",
              height: "1.5rem",
              backgroundColor: "#FAFBFC",
              cursor: "pointer",
            }}
          />
        </div>
      </div>
    </div>
  );
});

export default SelectLevelIKMC;
